export default function headlineStyling() {
	const articles = document.querySelectorAll('article');

	articles.forEach((el) => {
		if (el.hasAttribute('data-headline')) {
			let colour = el.getAttribute('data-headline')
			let headlines = el.querySelectorAll('h1');

			headlines.forEach((el) => {
				el.style.color = colour;
			})
		}
	});
}
